/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.13
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function JobTypeFromJSON(json) {
    return JobTypeFromJSONTyped(json, false);
}
export function JobTypeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'jobTypeId': !exists(json, 'jobTypeId') ? undefined : json['jobTypeId'],
        'tradeId': !exists(json, 'tradeId') ? undefined : json['tradeId'],
        'trade': !exists(json, 'trade') ? undefined : json['trade'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'jobTypeName': !exists(json, 'jobTypeName') ? undefined : json['jobTypeName'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'kindFilter': !exists(json, 'kindFilter') ? undefined : json['kindFilter'],
        'sort': !exists(json, 'sort') ? undefined : json['sort'],
        'cTradeFilter': !exists(json, 'cTradeFilter') ? undefined : json['cTradeFilter'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
        'creationTimestamp': !exists(json, 'creationTimestamp') ? undefined : (json['creationTimestamp'] === null ? null : new Date(json['creationTimestamp'])),
        'modificationTimestamp': !exists(json, 'modificationTimestamp') ? undefined : (json['modificationTimestamp'] === null ? null : new Date(json['modificationTimestamp'])),
    };
}
export function JobTypeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'jobTypeId': value.jobTypeId,
        'tradeId': value.tradeId,
        'trade': value.trade,
        'propertyId': value.propertyId,
        'jobTypeName': value.jobTypeName,
        'priority': value.priority,
        'kindFilter': value.kindFilter,
        'sort': value.sort,
        'cTradeFilter': value.cTradeFilter,
        'createdBy': value.createdBy,
        'modifiedBy': value.modifiedBy,
        'creationTimestamp': value.creationTimestamp === undefined ? undefined : (value.creationTimestamp === null ? null : value.creationTimestamp.toISOString()),
        'modificationTimestamp': value.modificationTimestamp === undefined ? undefined : (value.modificationTimestamp === null ? null : value.modificationTimestamp.toISOString()),
    };
}
